export default "__VITE_ASSET__2ab67aa9__"